<app-loader [isLoading]="isLoading"></app-loader>

@if(!isMobileView){
  <div class="modal-heading">
    <h2 class="modal-title">Select Area</h2>
    <div class="close-button" (click)="closeDialog()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>

  <div class="modal-container">
    <div class="d-flex filter-options">
      @if(showState) {
        <div class="custom-dropdown">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select
              class="custom-mat-select custom-select"
              id="state"
              placeholder="Select State"
            >
              <mat-option *ngFor="let state of states; let i = index" [value]="state" (click)="onStateChange(state)" (onSelectionChange)="onStateChange(state)">
                {{ state }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        @if(showDistrict) {
          <div class="custom-dropdown">
            <mat-form-field class="select-mat-form-field custom-select-form">
              <mat-select
                class="custom-mat-select custom-select"
                id="district"
                placeholder="Select District"
              >
                <mat-option *ngFor="let district of districtList; let i = index" [value]="district" (click)="onDistrictChange(district)" (onSelectionChange)="onDistrictChange(district)">
                  {{ district }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        }
      }

      @if(workerList.length) {
        <div class="custom-dropdown">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select
              class="custom-mat-select custom-select"
              id="worker"
              placeholder="Select Worker"
            >
              <mat-option *ngFor="let role of workerList; let i = index" [value]="role" (click)="onWorkerChange(role)">
                {{ role.toUpperCase() }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }

      <div class="btn-container">
        <button class="dp-secondary-btn btn-div" (click)="saveChanges()">
          Add
        </button>
      </div>
    </div>  
  </div>

      <!-- <div class="btn-container">
        <button class="dp-secondary-btn btn-div w-100" (click)="saveChanges()">
          Save</button>
      </div> -->

} @else {
  <div class="modal-heading">
    <h2 class="modal-title">Select Area</h2>
    <div class="close-button" (click)="closeDialog()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>

  <div class="modal-container">
    <div class="d-flex filter-options">
      <div class="custom-dropdown">
        <mat-form-field class="select-mat-form-field custom-select-form">
          <mat-select
            class="custom-mat-select custom-select"
            id="state"
            placeholder="Select State"
          >
            <mat-option *ngFor="let state of states; let i = index" [value]="state" (click)="onStateChange(state)">
              {{ state }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
   
      @if(selectedState != []) {
        <div class="custom-dropdown">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select
              class="custom-mat-select custom-select"
              id="district"
              placeholder="Select District"
            >
              <mat-option *ngFor="let district of districtList; let i = index" [value]="district" (click)="onDistrictChange(district)">
                {{ district }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="btn-container">
          <button class="dp-secondary-btn btn-div" (click)="saveChanges()">
            Submit
          </button>
        </div>

      }
    </div>  
  </div>
}
